import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CustomFieldsFormController', CustomFieldsFormController);

    function CustomFieldsFormController(
        $scope,
        CompanyFactory,
        CompaniesFactory,
        HousingAssociationsFactory,
        LocalStorageService
    ) {
        var vm = this;

        /**
         * Unfiltered means that this variable keeps all fields created by the active
         * company regardless of the client assigned to the field.
         *
         * Filtering is performed after choosing client and filtered fields are stored
         * in the vm.customFields.
         *
         * @type {*[]}
         */
        vm.unfilteredCompanyCustomFields = [];

        /**
         * Custom fields for the selected client. This fields are used for generating
         * form.
         *
         * @type {*[]}
         */
        vm.customFields = [];

        init();

        function init() {
            vm.userType = vm.userType || 'company';

            /**
             * In case, when company user is asking for custom fields.
             */
            if (vm.userType === 'company') {
                detectCompany().then(fetchCompanyCustomFields);
                return;
            }

            /**
             * In case, when client user is asking for custom fields.
             */
            if (vm.userType === 'client') {
                watchCompanyIdChanges();
                return;
            }
        }

        function detectCompany() {
            // We can check is component works for company or client by existing companyId. For company
            // we need to get it from LocalStorage or server. For client we know that id, because client
            // get it in select.
            return new Promise(function (resolve, reject) {
                var localCompanyObject = LocalStorageService.getObject(
                    'common/company'
                );
                if (vm.companyId) {
                    resolve(vm.companyId);
                } else if (localCompanyObject) {
                    resolve(localCompanyObject.organization.party_uuid);
                } else {
                    CompanyFactory.readCompany().then(function (response) {
                        LocalStorageService.saveObject(
                            'common/company',
                            response.data
                        );
                        resolve(response.data.organization.party_uuid);
                    });
                }
            });
        }

        function displayCustomFieldsForSelectedClient() {
            vm.customFields = vm.unfilteredCompanyCustomFields.filter(function (
                field
            ) {
                return (
                    field.customer === null ||
                    (vm.client
                        ? field.customer === vm.client.party_uuid
                        : false)
                );
            });
        }

        function fetchCompanyCustomFields(companyId) {
            CompaniesFactory.getCustomFields(companyId, { page_size: 50 }).then(
                function (response) {
                    vm.unfilteredCompanyCustomFields = response.data.results;

                    if (vm.filledCustomFields) {
                        fillCustomFields(vm.unfilteredCompanyCustomFields);
                    }

                    watchClientChanges();
                }
            );
        }

        function fetchClientCustomFields(companyId) {
            HousingAssociationsFactory.getCustomFields(companyId, {
                page_size: 50,
            }).then(function (response) {
                vm.customFields = response.data.results;

                if (vm.filledCustomFields) {
                    fillCustomFields(vm.customFields);
                }
            });
        }

        function fillCustomFields(rawCustomFields) {
            vm.filledCustomFields.forEach(function (filledCustomField) {
                var customFieldToFill = rawCustomFields.find(function (field) {
                    return filledCustomField.custom_field === field.id;
                });

                if (customFieldToFill) {
                    customFieldToFill.value = filledCustomField.value;
                }
            });
        }

        function watchClientChanges() {
            $scope.$watch(
                function () {
                    return vm.client;
                },
                function () {
                    displayCustomFieldsForSelectedClient();
                },
                true
            );
        }

        function watchCompanyIdChanges() {
            $scope.$watch(
                function () {
                    return vm.companyId;
                },
                function () {
                    if (!vm.companyId) {
                        vm.customFields = [];
                        return;
                    }

                    fetchClientCustomFields(vm.companyId);
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/custom_fields.controller.ts